<script lang="ts">
  export let muted: boolean = false;
  export let pendingPlayback: boolean = false;
  export let onPrev: () => void = () => {};
  export let onToggleMute: () => void = () => {};
  export let onNext: () => void = () => {};
</script>

<button id="btn-prev" class="nav-btn" aria-label="Previous Station" on:click={onPrev}>
  <svg class="nav-icon">
    <use href="#icon-prev" />
  </svg>
</button>

<button
  id="btn-mute"
  class="nav-btn"
  class:pending-playback={pendingPlayback}
  aria-label="Mute"
  on:click={onToggleMute}>
  {#if pendingPlayback}
    play
  {:else}
    <svg class="nav-icon">
      <use href={muted ? '#icon-speaker-off' : '#icon-speaker-on'} />
    </svg>
  {/if}
  {#if muted}
    <span class="mute-dot"></span>
  {/if}
</button>

<button id="btn-next" class="nav-btn" aria-label="Next Station" on:click={onNext}>
  <svg class="nav-icon">
    <use href="#icon-next" />
  </svg>
</button>
